import { MessageTemplateListPage } from './messageTemplate.list.page';

export default MessageTemplateListPage;